"use client";

import { useState } from "react";
import ImageGallery from "./ImageGallery";

export default function ImageGalleryWrapper() {
  const [current, setCurrent] = useState(0);

  return <ImageGallery current={current} setCurrent={setCurrent} />;
}
